import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const RefillCreditsLink = styled.div`
  color: ${COLORS.primaryDark};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
